/** Region catalog — mirrors backend constants/stores.js. The app name is always Ecatcho. */

export const STORE_IDS = {
  QATAR: 'qatar',
  INDIA: 'india',
};

export const DEFAULT_STORE_FEATURES = {
  qatar: {
    zoneAddress: true,
    pincodeAddress: false,
    deliveryBoyShipment: true,
    courierShipment: false,
    delhiveryTracking: false,
    returnOrders: true,
    dispatch: true,
    priorityDelivery: true,
    mapLinkCoords: true,
    reports: true,
    analytics: true,
    homepageCms: true,
  },
  india: {
    zoneAddress: false,
    pincodeAddress: true,
    deliveryBoyShipment: false,
    courierShipment: true,
    delhiveryTracking: true,
    returnOrders: true,
    dispatch: false,
    priorityDelivery: true,
    mapLinkCoords: false,
    reports: true,
    analytics: true,
    homepageCms: true,
  },
};

export const getCurrentStore = (adminData) => adminData?.currentStore || null;

export const getAdminRegion = (adminData) =>
  getCurrentStore(adminData)?.region === 'india' ? 'india' : 'qatar';

export const hasStoreFeature = (adminData, featureKey) => {
  const store = getCurrentStore(adminData);
  if (store?.features && typeof store.features[featureKey] === 'boolean') {
    return store.features[featureKey];
  }
  const region = getAdminRegion(adminData);
  return Boolean(DEFAULT_STORE_FEATURES[region]?.[featureKey]);
};
